/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCreateMstUsersRequest
 */
export interface RequestCreateMstUsersRequest {
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    approval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    baseFlg?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    baseId?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    chatworkRoomId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    commitment?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    createdUserId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    deposit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    driverName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    firstName: string;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    flg?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    introducer?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    isInitialPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    isLocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    isSuperAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    largeProduct?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    lineId?: string;
    /**
     * オプショナルフィールド
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    lineName?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    loginRetriedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    mail: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    monthlyCharge?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestCreateMstUsersRequest
     */
    noSticker?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    password: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    permissionId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    shippingNum?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateMstUsersRequest
     */
    shopName?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateMstUsersRequest
     */
    tenantId: number;
}

/**
 * Check if a given object implements the RequestCreateMstUsersRequest interface.
 */
export function instanceOfRequestCreateMstUsersRequest(value: object): value is RequestCreateMstUsersRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('mail' in value) || value['mail'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('permissionId' in value) || value['permissionId'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function RequestCreateMstUsersRequestFromJSON(json: any): RequestCreateMstUsersRequest {
    return RequestCreateMstUsersRequestFromJSONTyped(json, false);
}

export function RequestCreateMstUsersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateMstUsersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'approval': json['approval'] == null ? undefined : json['approval'],
        'baseFlg': json['base_flg'] == null ? undefined : json['base_flg'],
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'category': json['category'] == null ? undefined : json['category'],
        'chatworkRoomId': json['chatwork_room_id'] == null ? undefined : json['chatwork_room_id'],
        'commitment': json['commitment'] == null ? undefined : json['commitment'],
        'createdUserId': json['created_user_id'] == null ? undefined : json['created_user_id'],
        'deposit': json['deposit'] == null ? undefined : json['deposit'],
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'firstName': json['first_name'],
        'flg': json['flg'] == null ? undefined : json['flg'],
        'introducer': json['introducer'] == null ? undefined : json['introducer'],
        'isInitialPassword': json['is_initial_password'] == null ? undefined : json['is_initial_password'],
        'isLocked': json['is_locked'] == null ? undefined : json['is_locked'],
        'isSuperAdmin': json['is_super_admin'] == null ? undefined : json['is_super_admin'],
        'largeProduct': json['large_product'] == null ? undefined : json['large_product'],
        'lastName': json['last_name'],
        'lineId': json['line_id'] == null ? undefined : json['line_id'],
        'lineName': json['line_name'] == null ? undefined : json['line_name'],
        'loginRetriedCount': json['login_retried_count'] == null ? undefined : json['login_retried_count'],
        'mail': json['mail'],
        'monthlyCharge': json['monthly_charge'] == null ? undefined : json['monthly_charge'],
        'noSticker': json['no_sticker'] == null ? undefined : json['no_sticker'],
        'password': json['password'],
        'permissionId': json['permission_id'],
        'shippingNum': json['shipping_num'] == null ? undefined : json['shipping_num'],
        'shopName': json['shop_name'] == null ? undefined : json['shop_name'],
        'tenantId': json['tenant_id'],
    };
}

export function RequestCreateMstUsersRequestToJSON(json: any): RequestCreateMstUsersRequest {
    return RequestCreateMstUsersRequestToJSONTyped(json, false);
}

export function RequestCreateMstUsersRequestToJSONTyped(value?: RequestCreateMstUsersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'approval': value['approval'],
        'base_flg': value['baseFlg'],
        'base_id': value['baseId'],
        'category': value['category'],
        'chatwork_room_id': value['chatworkRoomId'],
        'commitment': value['commitment'],
        'created_user_id': value['createdUserId'],
        'deposit': value['deposit'],
        'driver_name': value['driverName'],
        'first_name': value['firstName'],
        'flg': value['flg'],
        'introducer': value['introducer'],
        'is_initial_password': value['isInitialPassword'],
        'is_locked': value['isLocked'],
        'is_super_admin': value['isSuperAdmin'],
        'large_product': value['largeProduct'],
        'last_name': value['lastName'],
        'line_id': value['lineId'],
        'line_name': value['lineName'],
        'login_retried_count': value['loginRetriedCount'],
        'mail': value['mail'],
        'monthly_charge': value['monthlyCharge'],
        'no_sticker': value['noSticker'],
        'password': value['password'],
        'permission_id': value['permissionId'],
        'shipping_num': value['shippingNum'],
        'shop_name': value['shopName'],
        'tenant_id': value['tenantId'],
    };
}

